import { render, staticRenderFns } from "./AllDestionations.vue?vue&type=template&id=2c3e2240&scoped=true"
import script from "./AllDestionations.vue?vue&type=script&lang=js"
export * from "./AllDestionations.vue?vue&type=script&lang=js"
import style0 from "./AllDestionations.vue?vue&type=style&index=0&id=2c3e2240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3e2240",
  null
  
)

export default component.exports